import { CountryCode } from '../api';
import { injectTSDI } from '../tsdi';
import { StudioStore } from '../studio-store';

export type CountryValidationConfig = { [key in CountryCode]?: boolean } & {
    '*': boolean;
};

export const shouldValidateForCountry = (config?: CountryValidationConfig) => {
    if (!config) {
        return true;
    }

    const { studioCountryCode = 'UNDEFINED' } = injectTSDI(StudioStore);

    const studioCountryEnabled = studioCountryCode && config[studioCountryCode];
    const wildCardEnabled = config['*'];

    if (studioCountryEnabled !== undefined) {
        return studioCountryEnabled;
    }

    return wildCardEnabled;
};
